var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTg(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 33C25.6127 33 33 25.6127 33 16.5C33 7.3873 25.6127 0 16.5 0C7.3873 0 0 7.3873 0 16.5C0 25.6127 7.3873 33 16.5 33Z",
    fill: "#FFF625"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.46817 16.3258C12.2783 14.2301 15.4857 12.8485 17.0906 12.181C21.6728 10.2751 22.625 9.944 23.2456 9.93307C23.3821 9.93066 23.6873 9.96449 23.8849 10.1249C24.0519 10.2604 24.0978 10.4433 24.1198 10.5717C24.1418 10.7002 24.1691 10.9927 24.1474 11.2213C23.8991 13.8303 22.8246 20.1618 22.278 23.0839C22.0467 24.3204 21.5913 24.735 21.1504 24.7756C20.1922 24.8638 19.4646 24.1423 18.5365 23.534C17.0843 22.5821 16.2639 21.9895 14.8543 21.0605C13.2252 19.987 14.2813 19.397 15.2097 18.4327C15.4526 18.1804 19.6744 14.3403 19.7561 13.992C19.7664 13.9484 19.7758 13.786 19.6794 13.7002C19.5829 13.6145 19.4405 13.6438 19.3377 13.6671C19.1921 13.7002 16.8722 15.2336 12.3779 18.2673C11.7194 18.7195 11.123 18.9398 10.5886 18.9283C9.99945 18.9155 8.86619 18.5951 8.02373 18.3213C6.99041 17.9854 6.16916 17.8078 6.24067 17.2374C6.27792 16.9403 6.68708 16.6364 7.46817 16.3258Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTg);
export default __webpack_public_path__ + "static/media/tg.f1e71853.svg";
export { ForwardRef as ReactComponent };